import React, { useEffect } from "react";
import { Card, CardContent, Typography, Button, Grid, Box } from "@material-ui/core";
import numeral from "numeral";
import { ClientServicingCss as Styles } from "./css/ClientServicingCss";
import { DATE_FORMAT_SERVICE_DASHBOARD } from "../../utils/dateUtils";
import { history } from "../../configureStore";
import StrategyName from "../client/StrategyName";
import moment from "moment";
import { useSelector } from "react-redux";
import { RootState } from "../../reducers";
import NumberFormat from "react-number-format";
import {
    getIndexOfCompletedYear,
    nextAnniversaryDate
} from "../../pages/clientServicing/ClientServiceDashbaord";
import dollarSign from "./Images/dollarSign.svg";
import paper from "./Images/035-paper.svg";
import hand from "./Images/036-hand.svg";
import clockNeedles from "./Images/097-clockNeedles.svg";
import { useActions } from "../../actions";
import * as ClientActions from "../../actions/client";
import MultiplePolicy from "../../pages/client/ClientProfile/component/MultiplePolicy";
import { ClientPolicies } from "../../model/clientPolicies";
import * as Actions from "../../actions/account";
import { getPolicyName, isPolicyIssued } from "../../pages/client/helper";
import PoliciesSelectBox from "../../pages/client/ClientProfile/component/PoliciesSelectBox";
export const getBloated = (val: string) => {
    return val.slice(0, 2) + "" + val.split("").filter((item, index) => index > 1).map(() => "*").join("");
};

const PaymentStatusCard = (props: {
    isPaymentDue: boolean,
    paymentDueBy: string,
    lastPaymentDue: number,
    redirectTo: Function
}) => {
    const { isPaymentDue, paymentDueBy, lastPaymentDue, redirectTo } = props;
    const classes = Styles();
    return <>
        <Card className={classes.cardRootHighlight + " " + classes.cardRoot + " " + classes.cardShadow + " " + classes.radius8 + " " + classes.minHeight170}>
            <CardContent className={classes.textCenter} style={{ verticalAlign: "middle", alignItems: "center" }}>
                <Typography variant="caption"
                            className={classes.disPlay + " " + classes.mb0}>
                    Payment Due By ${paymentDueBy}
                </Typography>
                <Typography component="strong" variant="h4"
                            className={classes.disPlay + " " + classes.mb0 + " " + classes.mt15}>
                    {numeral(lastPaymentDue).format("$0,0")}
                </Typography>
                <Button
                        variant="contained"
                        size="small"
                        className={classes.mt15}
                        onClick={() => redirectTo("/client/payments")}
                >
                    View Payments
                </Button>
            </CardContent>
        </Card>
    </>;
};
const CommonBox = (props: { src: string, typoText: string, alt: string, children: any }) => {
    const { src, typoText, alt } = props;
    const classes = Styles();
    return <Box p={1} className="cardWidth300">
        <Card className={classes.cardRoot + " " + classes.cardShadow + " " + classes.radius8 + " " + classes.minHeight170}>
            <CardContent className={classes.content}>
                <div className={classes.imgSec}>
                    <img src={src} alt={alt} />
                </div>
                <div className={classes.textSec}>
                    <Typography variant="caption"
                                className={classes.disPlay}>
                        {typoText}
                    </Typography>
                    {props.children}
                </div>
            </CardContent>
        </Card>
    </Box>;
};
export default function QuickView(props: any) {
    const classes = Styles();
    const { caseDetail, clientDetail, policyNumberSubText, callingFrom } = props;
    const clientCaseDetails: any = useSelector((state: RootState) => state.clientCaseDetails);
    const [isPaymentDue, setIsPaymentDue] = React.useState<boolean>(false);
    const paymentNotReceivedForYear = caseDetail && caseDetail.paymentNotDoneForYear || moment().year();
    const accountActions = useActions(Actions);
    let paymentNotReceivedPolicyBreakDown: any = [];
    let lastPaymentDue: number = 0;
    let completedYearPolicyBreakDown: any = [];
    let netDeathBenefit: any = 0;
    let estimatedCashValue: any = 0;
    const clientDetails = clientDetail && clientDetail.payload;
    const clientPolicys = clientDetails && clientDetails.client && clientDetails.client.clientPolicies.length > 0 && clientDetails.client.clientPolicies[0];
    let paymentDueBy: any = "N/A";

    React.useEffect(() => {
        let paymentReceivedForFiveYears = 0;
        caseDetail && caseDetail.policyBreakDowns && caseDetail.policyBreakDowns.length > 0 && caseDetail.policyBreakDowns.map((payment) => {
            let balanceAmount = numeral(payment && payment.clientContributionDue).value() - numeral(payment && payment.clientContributionReceived).value();
            if (balanceAmount === 0 || balanceAmount < 0) {
                paymentReceivedForFiveYears = paymentReceivedForFiveYears + 1;
            }
        });
        if (paymentReceivedForFiveYears >= 5) {
            setIsPaymentDue(false);
        } else {
            setIsPaymentDue(true);
        }
    }, [caseDetail]);


    const issueDate = clientCaseDetails && clientCaseDetails.tranche && clientCaseDetails.tranche.issueDate;
    let policyCompletedYearIndex: number = getIndexOfCompletedYear(issueDate);
    const anniversaryDate = nextAnniversaryDate(issueDate);
    let contributionDueDate = moment(anniversaryDate).subtract(30, "days");
    const month = contributionDueDate.format("MM");
    const day = contributionDueDate.format("DD");
    const updatedAnniversaryDate = (clientCaseDetails && clientCaseDetails.anniversaryDate) ? moment(clientCaseDetails.anniversaryDate).format(DATE_FORMAT_SERVICE_DASHBOARD) : null;

    if (paymentNotReceivedForYear && month && day) {
        paymentDueBy = `${month}/${day}/${paymentNotReceivedForYear}`;
    }
    let policyNumber: string = "N/A";

    if ((clientDetails && clientDetails.client && clientDetails.client.policyNumber) || (clientCaseDetails && clientCaseDetails.policyNumber)) {
        policyNumber = clientDetails && clientDetails.client && clientDetails.client.policyNumber || clientCaseDetails && clientCaseDetails.policyNumber;
    }
    let strategyName: string = "Kai-Zen";
    if (clientPolicys && clientPolicys.strategy && clientPolicys.strategy.name) {
        strategyName = clientPolicys.strategy.name;
    }

    if (caseDetail) {
        const { policyBreakDowns } = caseDetail;
        if (policyBreakDowns) {
            if (paymentNotReceivedForYear) {
                paymentNotReceivedPolicyBreakDown = policyBreakDowns.find(p => p.policyYear === paymentNotReceivedForYear);
                if (paymentNotReceivedPolicyBreakDown) {
                    lastPaymentDue = numeral(paymentNotReceivedPolicyBreakDown && paymentNotReceivedPolicyBreakDown.clientContributionDue).value() - numeral(paymentNotReceivedPolicyBreakDown && paymentNotReceivedPolicyBreakDown.clientContributionReceived).value();
                }
            }
            completedYearPolicyBreakDown = policyBreakDowns && policyBreakDowns[policyCompletedYearIndex];
            netDeathBenefit = completedYearPolicyBreakDown && (numeral(completedYearPolicyBreakDown.netStmDeathBenefits).value() || numeral(completedYearPolicyBreakDown.illustratedNetDeathBenefit).value() || 0);
            estimatedCashValue = completedYearPolicyBreakDown && (numeral(completedYearPolicyBreakDown.netStmSurrenderValue).value() || numeral(completedYearPolicyBreakDown.netLoanCashValueIllustrated).value() || 0);
        }
    }

    const redirectTo = (url: string) => {
        history.push(url);
    };
    const user = useSelector((state: RootState) => state.profile);
    const [clientPolicyList, setClientPolicyList] = React.useState<object[]>([]);
    const clientPolicy = (user && user.client && user.client.clientPolicies && user.client.clientPolicies[0]) as ClientPolicies;
    const { getClientPolicies, updateClientPolicy } = useActions(ClientActions);
    const clientId = user && user.client && user.client.id;
    const isAdmin = callingFrom === "ADMIN";


    return (
            <>

                <>
                    <Grid container spacing={2} className="mb10">
                        <Grid item xs={12}>
                            <PoliciesSelectBox redirectPath={"/client/dashboard"}
                            />
                            <Typography variant="caption" component="strong" align="left"
                                        className={classes.mt25 + " " + classes.mb15 + " " + classes.floatLeft + " " + classes.w100}>
                                Policy Number&nbsp;-&nbsp;{clientPolicy && clientPolicy.policyNumber}&nbsp;
                                <StrategyName strategyName={strategyName} />&nbsp;
                                {policyNumberSubText}
                                {/*<pre>{JSON.stringify(clientPolicy, null, 2)}</pre>*/}
                            </Typography>

                        </Grid>
                    </Grid>
                </>

                <Box
                        display="flex"
                        flexWrap="wrap"
                        style={{ marginBottom: "20px" }}
                >
                    <Box p={1} className="cardWidth300">
                        <PaymentStatusCard isPaymentDue={isPaymentDue} paymentDueBy={paymentDueBy}
                                           lastPaymentDue={lastPaymentDue} redirectTo={redirectTo} />
                    </Box>

                    {
                         isAdmin &&
                        <CommonBox src={dollarSign} typoText={"Last Year's Policy Growth Rate"}
                               alt="PolicyGrowthRate">
                        <Typography component="strong" variant="subtitle1"
                                    className={classes.disPlay + " " + classes.mb0 + " " + classes.mt15}>

                            {
                                completedYearPolicyBreakDown && completedYearPolicyBreakDown.stmWeightedGrowthRate ?
                                        <NumberFormat
                                                value={completedYearPolicyBreakDown.stmWeightedGrowthRate || completedYearPolicyBreakDown.illustratedGrowthRate || 0}
                                                displayType={"text"}
                                                suffix={"%"} /> : "N/A"
                            }
                        </Typography><br />
                        </CommonBox>
                    }
                    {
                        isAdmin && 
                        <CommonBox src={paper} typoText={"Estimated"} alt="NetDeathBenefit">
                            <Typography variant="caption"
                                        className={classes.disPlay + " " + classes.mb0}>
                                Net Death Benefit
                            </Typography>
                            <Typography component="strong" variant="subtitle1"
                                        className={classes.disPlay + " " + classes.mt15 + " " + classes.mb0}>
                                <NumberFormat
                                        value={netDeathBenefit}
                                        displayType={"text"}
                                        prefix={"$"}
                                        thousandSeparator={true}
                                        decimalSeparator={"."}
                                        decimalScale={2}
                                        fixedDecimalScale={true}
                                />
                            </Typography>
                        </CommonBox>
                    }
                    {
                        isAdmin && 
                        <CommonBox src={hand} typoText={"Estimated"} alt="NetCashValue">
                            <Typography variant="caption"
                                        className={classes.disPlay + " " + classes.mb0}>
                                Net Cash Value
                            </Typography>

                            <Typography component="strong" variant="subtitle1"
                                        className={classes.disPlay + " " + classes.mt15 + " " + classes.mb0}>
                                <NumberFormat
                                        value={estimatedCashValue}
                                        displayType={"text"}
                                        prefix={"$"}
                                        thousandSeparator={true}
                                        decimalSeparator={"."}
                                        decimalScale={2}
                                        fixedDecimalScale={true}
                                />
                            </Typography>
                        </CommonBox>
                    }

                    <CommonBox src={clockNeedles} typoText={"Policy"} alt="PolicyReturnRate">
                        <Typography variant="caption"
                                    className={classes.disPlay + " " + classes.mb0}>
                            Anniversary Date
                        </Typography>

                        <Typography component="strong" variant="subtitle1"
                                    className={classes.disPlay + " " + classes.mt15 + " " + classes.mb0}>
                            {updatedAnniversaryDate ? updatedAnniversaryDate : (anniversaryDate ? anniversaryDate : "N/A")}

                        </Typography>
                    </CommonBox>
                </Box>
            </>
    );
};